export default __webpack_public_path__ + "static/media/sp-app-operation-02.a7f4854d.png";